module.exports = __webpack_public_path__ + "static/media/2019-arsredovisning-brf-lyfta.1985d4b6.pdf";